import { AxiosInstance } from 'axios';
import * as TransactionListReportService from './services';

export type TransactionListReportServiceType = ReturnType<
  typeof TransactionListReportService.exportPDF
>;

export const initTransactionListReportService = (
  axios: AxiosInstance
): TransactionListReportServiceType => TransactionListReportService.exportPDF(axios);
